module.exports = __webpack_public_path__ + "ptc_momoro_G1.f2072078.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_G1.jpg
// module id = jqki
// module chunks = 0